
export default {
  data() {
    return {
      title: "Dimensions and Rates | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
